const initialState = {
  events: [],
  searchError: null,
};

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SEARCH_EVENTS_SUCCESS":
      return {
        ...state,
        events: action.events,
        searchError: null,
      };
    case "SEARCH_EVENTS_ERROR":
      return {
        ...state,
        searchError: action.error,
      };
    case "CREATE_EVENTS_SUCCESS":
      return state;
    case "CREATE_EVENTS_ERROR":
      return {
        ...state,
        createError: action.error,
      };
    case "DELETE_EVENTS_SUCCESS":
      return state;
    case "DELETE_EVENTS_ERROR":
      return {
        ...state,
        deleteError: action.error,
      };
    default:
      return state;
  }
};

export default eventReducer;
